
























































import { Component, Vue } from 'vue-property-decorator';
import logger from 'consola';
import Timeout = NodeJS.Timeout;

enum ESteps {
  Auth = 'Authentication',
  Connection = 'Connection to the cloud',
  Fetch = 'Fetch profile',

  SyncEntityStations = 'Sync entity "stations"',
  SyncEntitySoles = 'Sync entity "soles"',
  SyncEntityPatients = 'Sync entity "patients"',

  SyncAddons = 'Sync addons',

  Launch = 'Launch',
}
enum EStepsErrors {
  Auth = 'Authentication failed',
  Connection = 'Connection to the cloud failed',
  Fetch = 'Fetch profile failed',

  SyncEntityStations = 'Sync entity "stations" failed',
  SyncEntitySoles = 'Sync entity "soles" failed',
  SyncEntityPatients = 'Sync entity "patients" failed',

  SyncAddons = 'Sync addons failed',
}

@Component
export default class SplashScreen extends Vue {
  display = !this.$pdc.entities!.synchronizedAtLeastOnce;
  classes = ['overlay'];
  step: ESteps = ESteps.Auth;

  displaySignOut: boolean = false;
  displaySignOutTimeout: Timeout | null = null;

  error: any = null;
  render: boolean = false;

  noTransition: boolean = false;

  get isAuth() {
    return /^auth-/.test(this.$route.name!);
  }

  async hide() {
    // Fade off
    this.classes.push('off');
    // Clear timeout
    if (this.displaySignOutTimeout) clearTimeout(this.displaySignOutTimeout);
    // Hide loader
    setTimeout(() => {
      this.display = false;
    }, 400);
    // Render
    this.render = true;
  }

  async show() {
    // Logs
    logger.withTag('ui').info('🎨 Display loading overlay');
    // Reset display flag
    this.display = true;
    // Fade on
    this.classes = ['overlay'];
    // Clear timeout
    if (this.displaySignOutTimeout) clearTimeout(this.displaySignOutTimeout);

    this.displaySignOutTimeout = setTimeout(() => {
      this.displaySignOut = true;
    }, 4000);
  }

  // -------------------------------------------------------------------------------------------------------------------

  router__enter() {
    this.noTransition = false;
  }

  router__leave() {
    this.noTransition = true;
  }

  // -------------------------------------------------------------------------------------------------------------------

  auth__failedGetUser() {
    this.error = null;
    this.displaySignOut = true;
    this.render = true;
    this.hide();
  }

  repository__connectionPending() {
    this.step = ESteps.Connection;
  }
  repository__connectionError(e: Error) {
    this.error = { txt: EStepsErrors.Connection, e };
    this.displaySignOut = true;
  }

  doctor__fetchPending() {
    this.step = ESteps.Fetch;
  }
  doctor__notExist() {
    console.log('Doctor profile need to be created');
    this.$pdc.bus!.off('app:redirect-to-home', this.app__redirectToHome);
    this.$router.push('/auth/create-doctor-profile', () => {
      this.hide();
      this.render = true;
    });
  }
  doctor__fetchFailed(e: Error) {
    this.error = { txt: EStepsErrors.Fetch, e };
    this.displaySignOut = true;
  }

  entities__stationsSyncPending() {
    this.step = ESteps.SyncEntityStations;
  }
  entities__stationsSyncFailed(e: Error) {
    this.error = { txt: EStepsErrors.SyncEntityStations, e };
    this.displaySignOut = true;
  }

  entities__solesSyncPending() {
    this.step = ESteps.SyncEntitySoles;
  }
  entities__solesSyncFailed(e: Error) {
    this.error = { txt: EStepsErrors.SyncEntitySoles, e };
    this.displaySignOut = true;
  }

  entities__patientsSyncPending() {
    this.step = ESteps.SyncEntityPatients;
  }
  entities__patientsSyncFailed(e: Error) {
    this.error = { txt: EStepsErrors.SyncEntityPatients, e };
    this.displaySignOut = true;
  }

  app__ready() {
    this.step = ESteps.Launch;

    if (!this.error) {
      this.hide();
      this.render = true;
    }
  }

  // -------------------------------------------------------------------------------------------------------------------

  signOut() {
    this.$pdc.cognito!.signOut();
    this.hide();
    // Redirect...
    this.$router.push('/auth/sign-in');
  }

  app__redirectToHome() {
    console.log('Redirect to home');
    this.$router.push('/');
  }

  created() {
    this.$pdc.bus!.on('router:enter', this.router__enter);
    this.$pdc.bus!.on('router:leave', this.router__leave);

    // Auth
    this.$pdc.bus!.on('auth:failed-get-user', this.auth__failedGetUser);

    // Repository
    this.$pdc.bus!.on('repository:connection-pending', this.repository__connectionPending);
    this.$pdc.bus!.on('repository:error', this.repository__connectionError);
    this.$pdc.bus!.on('repository:disconnected', (reason: string) => {
      if (reason === 'io server disconnect') {
        this.render = true;
        this.hide();
      } else {
        this.repository__connectionError(new Error(reason));
      }
    });

    // Fetch profile
    // this.$pdc.bus!.on('doctor:fetch-pending', this.doctor__fetchPending);
    this.$pdc.bus!.on('doctor:not-exist', this.doctor__notExist);
    this.$pdc.bus!.on('doctor:fetch-fail', this.doctor__fetchFailed);

    // Entities (stations)
    // this.$pdc.bus!.on('entities:stations-sync-pending', this.entities__stationsSyncPending);
    this.$pdc.bus!.on('entities:stations-sync-failed', this.entities__stationsSyncFailed);

    // Entities (soles)
    // this.$pdc.bus!.on('entities:soles-sync-pending', this.entities__solesSyncPending);
    this.$pdc.bus!.on('entities:soles-sync-failed', this.entities__solesSyncFailed);

    // Entities (patients)
    // this.$pdc.bus!.on('entities:patients-sync-pending', this.entities__patientsSyncPending);
    this.$pdc.bus!.on('entities:patients-sync-failed', this.entities__patientsSyncFailed);

    this.$pdc.bus!.on('app:ready', this.app__ready);
    this.$pdc.bus!.on('doctor:created', this.app__ready);

    this.$pdc.bus!.on('app:init', this.show);
  }

  beforeDestroy() {
    this.$pdc.bus!.off('router:enter', this.router__enter);
    this.$pdc.bus!.off('router:leave', this.router__leave);

    // Auth
    this.$pdc.bus!.off('auth:failed-get-user', this.auth__failedGetUser);

    // Repository
    this.$pdc.bus!.off('repository:connection-pending', this.repository__connectionPending);
    this.$pdc.bus!.off('repository:error', this.repository__connectionError);

    // Fetch profile
    // this.$pdc.bus!.off('doctor:fetch-pending', this.doctor__fetchPending);
    this.$pdc.bus!.off('doctor:not-exist', this.doctor__notExist);
    this.$pdc.bus!.off('doctor:fetch-fail', this.doctor__fetchFailed);

    // Entities (stations)
    // this.$pdc.bus!.off('entities:stations-sync-pending', this.entities__stationsSyncPending);
    this.$pdc.bus!.off('entities:stations-sync-failed', this.entities__stationsSyncFailed);

    // Entities (soles)
    // this.$pdc.bus!.off('entities:soles-sync-pending', this.entities__solesSyncPending);
    this.$pdc.bus!.off('entities:soles-sync-failed', this.entities__solesSyncFailed);

    // Entities (patients)
    // this.$pdc.bus!.off('entities:patients-sync-pending', this.entities__patientsSyncPending);
    this.$pdc.bus!.off('entities:patients-sync-failed', this.entities__patientsSyncFailed);

    this.$pdc.bus!.off('app:ready', this.app__ready);
    this.$pdc.bus!.off('doctor:created', this.app__ready);

    this.$pdc.bus!.off('app:init', this.show);
  }
}
